export * from "./styles";

export const THEME_VARIANT = {
  DARK: "dark",
  LIGHT: "light"
};

export const TOKEN_STORAGE_KEY = "ac";
export const USER_CONFIG_STORAGE_KEY = "usc";
export const noop = () => {};
export const sessionExpireMsg =
  "Session expired! Redirecting to login screen..";
export const DEFAULT_ERROR_MESSAGE =
  "Something went wrong, please contact system administrator.";
export const ACCESS_DENIED_MESSAGE =
  "You don't have permission to perform this action. Please contact system administrator";

export const PhoneRegexE164 = /^$|^\+\d{11,13}$/;

export const VALIDATIONS = {
  ALPHANUMERIC: "alphanumeric",
  MAX_LENGTH: "maxLength",
  MIN_LENGTH: "minLength",
  MAX: "max",
  MIN: "min",
  INTEGER: "integer",
  FLOAT: "float",
  NUMBER: "number",
  REQUIRED: "required",
  EMAILS: "emails",
  REGEX: "regex",
  PHONE: "phone"
};
export const PAGE_KEYS = {
  USER_PERMISSION: "user_permission",
  ADMIN_USER: "admin_user"
};
